import React, { PureComponent } from "react";
import { isDevelopment } from "services/environment-service";

const HTTP_TYPE = isDevelopment ? "http://" : "https://";
const DOMAIN = isDevelopment ? "localhost:3000" : process.env.PLATFORM_DOMAIN; // Google wont let lvh.me work with http, cant run lvh.me over https
const COOKIE_DOMAIN = `auth.${DOMAIN}`;

const LOGIN_URL_PREFIX = isDevelopment ? `${HTTP_TYPE}${DOMAIN}` : `${HTTP_TYPE}${COOKIE_DOMAIN}`;
const LOGIN_URL = `${LOGIN_URL_PREFIX}/users/auth/google_one_tap/callback`;

const client_id = process.env["google_on_tap/client_id"];
export default class GoogleOnetapScript extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <script src="https://accounts.google.com/gsi/client" />
        <div
          id="g_id_onload"
          data-client_id={client_id}
          data-login_uri={LOGIN_URL}
          data-state_cookie_domain={COOKIE_DOMAIN}
        />
      </>
    );
  }
}
